export const CONSTANTS = {
    PARTIES: {
        NPP: 'NPP'
    },
    REGIONS: {
        HEADQUARTERS: 'NPP HEADQUARTERS'
    },
    TITLES: {
        MAP_HEADER: 'NPP PRIMARIES 2024'
    },
    ASSETS: {
        IMAGES: {
            BAWUMIA: '/images/primaries/npp/bawumia.jpeg',
            KEN: '/images/primaries/npp/ken-agyapong.jpg',
            AKOTO: '/images/primaries/npp/akoto.jpg',
            Kwala: '/images/primaries/npp/kwala.jpg',
        }
    }
}
